import React from 'react';
import {Box, Grid } from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import '../styles/bizofficer-a.css';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

  export default function Execute() {
	const classes = useStyles();
	
		return (
			<div> 
				<MetaTags>
            		<title>In-App Payment</title>
          		</MetaTags>
				
				<Header />	
				<LeftDrawer />
				<main className={classes.content}>
				

				<Box mt={1}>
						<Grid container spacing={2}>
							<Grid item   md={12} xs={12} style={{textAlign:'center'}}>
								<h3 className="heading" style={{color:'#0000FF'}} >In-App Purchases</h3>
								
								<br/>
								<p>
								<a href="selectcourse">Select Your Course</a>
								</p>
								<br/> OR <br/><br/> 
								<p>
								<a href="dashboard">Go to your dashboard</a>
								</p>
							</Grid>
						</Grid>
				</Box>				

				

					

				</main>
				
				

			</div>
		);
 
}